module.exports = __webpack_public_path__ + "img/ring_g_c_1_1@2x.de8e415b.png";